import React, { useState, useEffect } from "react";
import { sensorUpdateData } from "../../services/sensors/sensorsService";
import { getCropTypes } from "../../services/v2/adminService";

const SensorEditModal = ({ sensor, onClose, onUpdate }) => {
    const [cropTypes, setCropTypes] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        cropTypeId: '',
        description: '',
        sendMail: false,
    });

    useEffect(() => {
        const fetchCropTypes = async () => {
            try {
                const data = await getCropTypes();
                setCropTypes(data || []);
            } catch (error) {
                console.error('Error al cargar los tipos de cultivo', error);
            }
        };
        fetchCropTypes();
    }, []);

    useEffect(() => {
        if (sensor) {
            setFormData({
                name: sensor.name || '',
                cropTypeId: sensor.crop?.cropType?.id != null ? String(sensor.crop.cropType.id) : '',
                description: sensor.description || '',
                sendMail: sensor.sendMail || false,
            });
        }
    }, [sensor]);

    const handleFormChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSaveSensor = async (event) => {
        event.preventDefault();

        const sensorData = {
            active: sensor.active,
            checked: sensor.checked,
            crop: {
                id: sensor.crop?.id ?? null,
                cropType: { id: Number(formData.cropTypeId) },
            },
            description: formData.description,
            id: sensor.id,
            name: formData.name,
            sendMail: formData.sendMail,
            sensorVariablesString: sensor.sensorVariablesString,
            sim: sensor.sim,
            startOperation: sensor.startOperation
        };

        try {
            await sensorUpdateData(sensorData);
            onUpdate(sensorData);
            onClose();
        } catch (error) {
            console.error('Error al enviar el formulario: ', error);
            alert("Error al enviar el formulario. Por favor, intenta de nuevo.");
        }
    };

    return (
        <div className="flex fixed inset-0 z-0 items-center justify-center p-4 bg-gray-900 bg-opacity-80">
            <div className="w-full max-w-md bg-white shadow-lg rounded">
                <div className="relative flex items-center p-4 text-black">
                    <h2 className="text-xl font-semibold">Modificar <span className="text-blue-600">{sensor.name}</span></h2>
                    <button type="button" className="absolute top-0 right-0 mt-4 mr-4 hover:text-red-500 w-6 h-6">
                        <span onClick={onClose} className="material-icons text-2xl font-bold">close</span>
                    </button>
                </div>

                <div className="px-4 text-black h-auto overflow-y-auto">
                    <form onSubmit={handleSaveSensor} className="flex flex-col items-center space-y-3 pb-2">
                        <div className='w-full'>
                            <label htmlFor="name" className="block font-semibold text-black mb-1"> Nombre del sensor <span className="text-red-500">*</span></label>
                            <input id="name" type="text" autoComplete="off"
                                name="name"
                                value={formData.name} 
                                onChange={handleFormChange}
                                placeholder="Nombre del sensor"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                            />
                        </div>

                        <div className="w-full">
                            <label htmlFor="crop" className="block font-semibold text-black mb-1"> Cultivo <span className="text-red-500">*</span></label>
                            <select id="crop"
                                name="cropTypeId"
                                value={formData.cropTypeId}
                                onChange={handleFormChange}
                                className="block items-center w-full px-1 py-1 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                            >
                                <option value="" disabled>Cultivo</option>
                                {cropTypes.map((cropType) => (
                                    <option key={cropType.id} value={cropType.id} className="text-black">
                                        {cropType.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='w-full'>
                            <label htmlFor="description" className="block font-semibold text-black mb-1"> Descripción <span className="text-red-500">*</span></label>
                            <textarea id="description" autoComplete="off"
                                name="description"
                                value={formData.description} 
                                onChange={handleFormChange}
                                placeholder="Descripción"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded resize-none"
                            ></textarea>
                        </div>

                        <div className='w-full flex items-center'>
                            <input id="sendMail"
                                type="checkbox" 
                                name="sendMail" 
                                checked={formData.sendMail} 
                                onChange={handleFormChange} 
                                className="mr-2"
                            />
                            <label htmlFor="sendMail" className="text-black">Recibir notificaciones</label>
                        </div>

                        <div className="flex items-center justify-center space-x-4">
                            <div className="w-full">
                                <button type="submit" className="flex flex-1 rounded w-full justify-center text-white bg-blue-600 hover:bg-blue-800 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200">
                                <span className="material-icons mr-2">save</span>Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SensorEditModal;